export default __webpack_public_path__ + "static/media/pencil-case.a3afeccf.png";